import React from 'react';
import styled from 'styled-components';
import Hyper from '../../../Component/Images/hyper.png';
import { Button } from '../../../Component/styledComponents/styledComponents';
import { useNavigate } from 'react-router-dom';

const Card = styled.div`
background-color: #282828;
border-radius:10px;
padding:40px 90px;
`;
const Heading = styled.div`
font-size:24px;
color:#fff;
font-weight:bold;
margin-bottom:20px;
`;
const Text = styled.div`
color:#9b9b9b ;
font-size:18px;
`;
const IconSection = styled.div`
margin-top:40px;
display:flex;
align-items: center;
width:100%;
justify-content: space-between;
`;
const IconWrapper = styled.div`
text-align:center;
`;
const Icon = styled.img`
/* width:32px; */
`;
const Subtitle = styled.div`
color:#9b9b9b ;
margin-top:5px;
`;
function HyperledgerFabric(props) {
   const navigate = useNavigate();
    return (
        <div>
          <Card>
        <Heading>
        Hyperledger fabric 
        </Heading>
        <Text>
        We manage scalable permissioned network using Hyperledger Fabric and ensure a shared infrastructure to enterprises, helping them in developing significant breakthroughs.  
        </Text>
        <IconSection>
             <IconWrapper>
                <Icon src={Hyper} alt="Hyperledger fabric" />
                {/* <Subtitle>hyper</Subtitle> */}
             </IconWrapper>

             {/* <IconWrapper>
                <Icon src={UnityLogo}/>
                <Subtitle>Blender</Subtitle>
             </IconWrapper>

             <IconWrapper>
                <Icon src={UnityLogo}/>
                <Subtitle>After Effects</Subtitle>
             </IconWrapper>
             <IconWrapper>
                <Icon src={UnityLogo}/>
                <Subtitle>Unreal</Subtitle>
             </IconWrapper> */}
        </IconSection>
        <Button
        border="#9b9b9b"
        color="#fff"
        top="12px"
        right="30px"
        left="30px"
        bottom="12px"
        radius="30px"
        mtop="40px"
        onClick={() => navigate('/contact_us')}
        >
          EXPLORE
        </Button>
      </Card>
        </div>
    );
}

export default HyperledgerFabric;